import React, { ReactElement } from 'react';
import dynamic from 'next/dynamic';
import classNames from 'classnames/bind';
import RootLayout from 'layouts/RootLayout';
import styles from 'pages/digital-tools/ship-schedules/ShipSchedules.module.scss';

const cn = classNames.bind(styles);

const SectionHeader = dynamic(() => import('sections/DigitalTools/ShipSchedules/components/SectionHeader'));
const SectionCoverage = dynamic(() => import('sections/DigitalTools/ShipSchedules/components/SectionCoverage'));
const SectionBenefits = dynamic(() => import('sections/DigitalTools/ShipSchedules/components/SectionBenefits'));
const SectionSolutions = dynamic(() => import('sections/DigitalTools/ShipSchedules/components/SectionSolutions'));
const SectionFeatures = dynamic(() => import('sections/DigitalTools/ShipSchedules/components/SectionFeatures'));
const SectionCallToAction = dynamic(() => import('sections/DigitalTools/ShipSchedules/components/SectionCallToAction'));
const SectionFaq = dynamic(() => import('sections/DigitalTools/ShipSchedules/components/SectionFaq'));

export default function ShipSchedules(): ReactElement {
  return (
    <div className={cn('ship-schedules')}>
      <SectionHeader />
      <SectionCoverage />
      <SectionBenefits />
      <SectionSolutions />
      <SectionFeatures />
      <SectionCallToAction />
      <SectionFaq />
    </div>
  );
};

export const getStaticProps = async () => {
  return {
    props: {
      title: 'Shipping Schedules | DF Alliance',
      description: 'Manage and view real-time ship schedules — plan routes, optimize logistics & stay on schedule. DF Alliance digital tools for logistics efficiency.',
      path: '/digital-tools/ship-schedules',
    },
  };
};

ShipSchedules.getLayout = function getLayout(page: ReactElement) {
  return <RootLayout>{page}</RootLayout>;
};
